import { useEffect, useState } from 'react';
import { subscribeMessages } from '@/services/chatService';
import type { ChatMessage } from '@/types/support';

export function useRealtimeMessages(requestId: string | null) {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(Boolean(requestId));

  useEffect(() => {
    if (!requestId) {
      setMessages([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const unsub = subscribeMessages(requestId, (msgs) => {
      setMessages(msgs);
      setLoading(false);
    });
    return unsub;
  }, [requestId]);

  return { messages, loading };
}
